export default __webpack_public_path__ + "static/media/testimonial-avatar-3.bcbe22be.jpg";